import { AccessToken, AuthPluginError, GetTokenOptions } from '../types';
import { AuthPluginFacade } from '../facades/AuthPluginFacade';
import { internalLogger } from '../../../interface/v1/clientOsLogger';

class InitializationTokenCache {
  private static cachedToken: AccessToken | null = null;
  private static isAlive = true;

  public static async getToken(
    options?: GetTokenOptions
  ): Promise<AuthPluginError | AccessToken> {
    if (!this.isAlive) {
      return null;
    }

    if (this.cachedToken) {
      internalLogger?.debug?.d5?.({
        className: 'InitializationTokenCache',
        methodName: 'getToken()',
        message: 'Using cached token during initialization'
      });
      return this.cachedToken;
    }

    internalLogger?.debug?.d5?.({
      className: 'InitializationTokenCache',
      methodName: 'getToken()',
      message: 'First getToken call during initialization - caching result'
    });
    const result = await AuthPluginFacade.getToken(options);

    if (result && !(result as AuthPluginError).error) {
      this.cachedToken = result as AccessToken;
    }

    return result;
  }

  public static killCache(): void {
    this.cachedToken = null;
    this.isAlive = false;
    internalLogger?.debug?.d5?.({
      className: 'InitializationTokenCache',
      methodName: 'killCache()',
      message: 'Token cache cleared after initialization'
    });
  }

  public static getCachedToken(): AccessToken {
    return this?.cachedToken;
  }
}

export default InitializationTokenCache;
